import TableBody from '@material-ui/core/TableBody';
/** @deprecated */
export default TableBody;
